import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHook: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="hook, phishing"><circle cx="9.25" cy="5.75" r="3" stroke="currentColor" strokeWidth="1.5"/><path d="M9.25 9V17.5C9.25 19.5711 10.9289 21.25 13 21.25C15.0711 21.25 16.75 19.5711 16.75 17.5V12L13.75 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHook;
